<template>
  <div class="addHomework">
    <el-card>
      <div class="addHomework_width">
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth">
          <el-form-item label="作业标题" prop="courseId">
            <div>
            <el-input
              type="textarea"
              v-model="addForm.content"
              placeholder="请输入此次作业标题"
              class="addHomework_input"
            ></el-input>
            <div class="flex-starts addHomework_button">
              <div class="addHomework_icon" @click="photoMaterialDialog=true">
                <div class="iconfont icon-lunbotu addHomework_icon_item"></div>
                <!-- <div>图片</div> -->
              </div>
              <div class="addHomework_icon" @click="examDialog=true">
                <div class="iconfont icon-zhangjie addHomework_icon_item"></div>
                <!-- <div>题库</div> -->
              </div>
            </div>
            </div>
          </el-form-item>
          <el-form-item label="图片" v-if="imgList.length > 0">
            <div class="addHomeworkList_material">
              <div v-for="item in imgList" :key="item.id" class="addHomeworkList_material_item"  @mouseover="item.hoverBlock = true" @mouseleave="item.hoverBlock = false">
                <img class="addHomeworkList_material_img" :src="item.url"/>
                <div v-if="item.hoverBlock" class="addHomeworkList_material_delete el-icon-delete" @click="delectMateria(item.id)"></div>
              </div>
              <!-- <div class="addHomeworkList_text">{{item.name}}</div> -->
              <!-- <div class="el-icon-error addHomeworkList_error" @click="delectMateria(item.id)"></div> -->
            </div>
          </el-form-item>
          <el-form-item label="试题" v-if="questionList.length > 0">
            <el-table :data="questionList" border style="width: 100%" row-key="id">
              <el-table-column
                label="排序"
                type="index"
                width="50"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="questionTypeName"
                label="题型"
                width="100"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column prop="title" label="题干" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-html="scope.row.title">大题</span>
                </template>
              </el-table-column>
              <el-table-column prop="answer" label="答案" width="80" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="操作" width="80" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="operation-style" @click="delectQuestion(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- <el-form-item label="提交截止时间" prop="courseId">
            <el-date-picker
              size="small"
              v-model="addForm.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="提醒时间" prop="courseId">
            <el-date-picker
              size="small"
              v-model="addForm.time"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item>-->
          <el-form-item label="发送方式" prop="courseId">
            <el-radio v-model="addForm.sendType" :label="1">立即发送</el-radio>
            <!-- <el-radio v-model="addForm.sendType" :label="2">定时发送</el-radio> -->
          </el-form-item>
          <el-form-item label="定时发送时间" prop="courseId" v-if="addForm.radio==2">
            <el-date-picker
              size="small"
              v-model="addForm.time"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="text-align:left">
            <el-button @click="goback">取消</el-button>
            <el-button type="primary" @click="addHomework" :loading="addHomeworkBlock">提交</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
          title="选择图片"
          :visible.sync="photoMaterialDialog"
          :close-on-click-modal="true"
          width="70%"
        >
          <photoMaterial @photoChange="photoChange"></photoMaterial>
        </el-dialog>
        <el-dialog
          title="从题库选择"
          :visible.sync="examDialog"
          :close-on-click-modal="false"
          width="70%"
        >
          <question v-if="examDialog" :courseId="courseId" @sentMsg="getMsg"></question>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
import photoMaterial from "../common/photoMaterial";
import question from "../common/question";
export default {
  components: { photoMaterial, question },
  data() {
    return {
      addHomeworkBlock: false,
      photoMaterialDialog: false,
      examDialog: false,
      formLabelWidth: "90px",
      questionList: [],
      imgList: [],
      courseId: this.$route.query.courseId,
      addForm: {
        sendType: 1,
        endTime: null,
        content: null,
        classInfoId: null,
        scheduleInfoId: null,
        questionList: [],
        videoInfoList: [],
        attachmentList: [],
        imgList: [],
      },
    };
  },
  computed: {},
  created() {},
  methods: {
    /*---------------------------图片处理---------------------------- */
    photoChange(ids) {
      ids.forEach((e) => {
        let idRepeat = false;
        this.imgList.forEach(i=>{
          if(i.id == e.id){
            idRepeat = true
          }
        })
        if(!idRepeat){
          this.$set(e,'hoverBlock',false)
          this.imgList.push(e);
        }
      });
      this.photoMaterialDialog = false;
    },

    delectMateria(id) {
      this.$confirm("将会删除该图片，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.imgList.forEach((e, index) => {
            if (e.id == id) {
              this.imgList.splice(index, 1);
            }
          });
        })
    },

    /*---------------------------题库处理---------------------------- */
    getMsg(val) {
      val.forEach((item) => {
        let idRepeat = false;
        this.questionList.forEach(i=>{
          if(i.id == item.id){
            idRepeat = true
          }
        })
        if(!idRepeat){
          this.questionList.push(item);
        }
      });

      this.examDialog = false;
    },

    delectQuestion(id){
      this.$confirm("将会删除该题，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.questionList.forEach((e, index) => {
            if (e.id == id) {
              this.questionList.splice(index, 1);
            }
          });
        })
    },

    /*---------------------------发布作业---------------------------- */
    goback(){
      this.$router.go(-1)
    },

    addHomework() {
      if(!this.addForm.content) {
        return this.$message.error("请输入作业标题！")
      }
      if (this.addHomeworkBlock) {
        return;
      }
      this.addHomeworkBlock = true;
      this.addForm.classInfoId = this.$route.query.classInfoId;
      this.addForm.scheduleInfoId = this.$route.query.scheduleInfoId;
      this.imgList.forEach((e) => {
        this.addForm.imgList.push({ id: e.id });
      });
      this.questionList.forEach((item) => {
        this.addForm.questionList.push({ id: item.id });
      });
      this.api.homework.addHomework(this.addForm).then((result) => {
        if (result.success) {
          this.addHomeworkBlock = false;
          this.addForm.imgList = [];
          this.addForm.questionList = [];
          this.$router.push({path:'/classRoomTeaching'})
        }
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="less" rel="stylesheet/less">
.addHomework {
  .el-card{
    min-height: calc(100vh - 150px);
  }
  .el-form-item__label {
    font-weight: 400;
  }
  .addHomework_width {
    width: 60%;
  }
  .addHomework_button {
    margin-top: 10px;
    line-height: 20px;
  }
  .addHomework_icon {
    margin-right: 10px;
    cursor: pointer;
  }
  .addHomework_icon_item {
    text-align: center;
    font-size: 26px;
  }
  .addHomework_form {
    margin-top: 20px;
  }
  .addHomeworkList_material {
    // background-color: #ccc;
    margin-top: 10px;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;

  }
  .addHomeworkList_material_img {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .addHomeworkList_text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .addHomeworkList_error {
    cursor: pointer;
    font-size: 18px;
    opacity: 0.6;
  }
  .addHomeworkList_material_item{
    position: relative;
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .addHomeworkList_material_delete{
    position: absolute;
    top: 0px;
    left: 0px;
    height: 80px;
    width: 80px;
    font-size: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 80px;
    background-color: #ccc;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/addHomework.vue